import React from "react";
import { NavLink } from "react-router-dom";

const PropsList = ({ filmId, sceneId, sceneCostumes }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Costumes in scene</p>
      <ul className="menu-list">
        {(sceneCostumes || []).map((costume, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/costumes/${costume.id}/edit`}
                activeClassName="is-active"
              >
                {costume.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default PropsList;
